export const getBestOfLabel = (juegosParaGanar, fallback = 4) => {
  const juegos = Number(juegosParaGanar);
  const juegosEfectivos = Number.isFinite(juegos) && juegos > 0 ? juegos : fallback;
  return `Best of ${juegosEfectivos * 2 - 1}`;
};

export const buildChampionshipConfig = ({
  tipoEliminacion,
  juegosParaGanar,
  juegosParaGanarLoser,
  juegosParaGanarFinal,
}) => {
  const winnerGames = Number(juegosParaGanar) || 4;
  const finalGames = tipoEliminacion === 'simple' && juegosParaGanarFinal ? Number(juegosParaGanarFinal) : null;

  return {
    juegosParaGanar: winnerGames,
    juegosParaGanarLoser: tipoEliminacion === 'simple' ? null : (juegosParaGanarLoser ?? null),
    juegosParaGanarFinal: tipoEliminacion === 'simple' ? finalGames : null,
    formatoFinal: getBestOfLabel(finalGames || winnerGames),
    resetBracket: tipoEliminacion === 'doble',
    seeding: 'random',
  };
};

export const getBracketFormatLabel = ({ modoVista, tipoEliminacion, configuracion }) => {
  const winnerLabel = getBestOfLabel(configuracion?.juegosParaGanar);

  if (tipoEliminacion === 'simple') {
    const finalLabel = getBestOfLabel(
      configuracion?.juegosParaGanarFinal ?? configuracion?.juegosParaGanar,
    );

    return finalLabel === winnerLabel
      ? winnerLabel
      : `Winner ${winnerLabel} · Final ${finalLabel}`;
  }

  if (modoVista === 'loser') {
    return getBestOfLabel(
      configuracion?.juegosParaGanarLoser ?? configuracion?.juegosParaGanar,
    );
  }

  return winnerLabel;
};